import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Table from './Table'
import { HeaderView } from '@merchant-backend/common-components'
import store from './store'
import { Select, Button } from 'hljd'
import Style from './style.module.less'
import { getCaseName } from '@util'
const Option = Select.Option

@observer
export default class extends Component {
  componentDidMount() {
    store.merchantCategory()
  }

  constructor(props) {
    super(props)
    const {
      location: {
        query: { is_shop }
      }
    } = this.props
    store.getIsShop(is_shop)
  }

  render() {
    const { categoryList, merchant_category_id } = store

    return (
      <HeaderView title={`${getCaseName()}排序`}>
        <div className={Style.page}>
          <div style={{ margin: '14px 0' }}>
            <Select
              style={{ width: 150 }}
              onChange={store.changeValue}
              value={merchant_category_id}
            >
              <Option value="">选择分类</Option>
              {categoryList.map(item => (
                <Option value={item.id + ''} key={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>

            <Button style={{ marginLeft: 10 }} onClick={store.reset}>
              重置
            </Button>
          </div>
          <Table />
        </div>
      </HeaderView>
    )
  }
}
